export default [
  {
    path: '/real-estate-developments-settings/buying-options',
    name: 'BuyingOptionsList',
    component: () => import('pages/real-estate-developments-settings/buying-options/BuyingOptionsList.vue')
  },
  {
    path: '/real-estate-developments-settings/buying-options/new',
    name: 'BuyingOptionsCreate',
    component: () => import('pages/real-estate-developments-settings/buying-options/BuyingOptionsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/buying-options/:id/edit',
    name: 'BuyingOptionsEdit',
    component: () => import('pages/real-estate-developments-settings/buying-options/BuyingOptionsForm.vue')
  }
]
